"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var defaults_1 = __importDefault(require("../defaults"));

var dimensions_1 = require("../dimensions");

var create_error_1 = __importDefault(require("./create-error")); // import createError from './create-error';


var assemblyDefaults = defaults_1.default.assemblyAccessories;

exports.validateConsole = function (assemblyAccessories, defaults, trough, isVariusMed, isVariusMedRWT) {
  var error = undefined;

  if (assemblyAccessories && assemblyAccessories.selection) {
    if (isVariusMedRWT) {
      defaults.console = Object.assign({}, assemblyDefaults.console, {
        default: 'miranit',
        dimensions: {
          miranit: dimensions_1.installaionParts.consoles.miranit
        },
        values: ['miranit']
      });

      if (assemblyAccessories.console && assemblyAccessories.console !== 'miranit') {
        error = create_error_1.default({
          msg: "{{" + assemblyAccessories.console + "}} isn't assignable to {{" + trough.name + "}}.",
          code: 'NOT_ASSIGNABLE',
          inObject: 'assemblyAccessories.console',
          statusCode: 400
        });
      }
    } else if (!isVariusMedRWT && isVariusMed) {
      defaults.console = Object.assign({}, assemblyDefaults.console, {
        default: 'miranit',
        values: ['stainlessSteel', 'stainlessSteelWhite', 'miranit'],
        dimensions: assemblyDefaults.console.dimensions
      });
    } else {
      defaults.console = Object.assign({}, assemblyDefaults.console, {
        default: 'stainlessSteel',
        values: ['stainlessSteel', 'stainlessSteelWhite'],
        dimensions: assemblyDefaults.console.dimensions
      });

      if (assemblyAccessories.console && assemblyAccessories.console === 'miranit') {
        error = create_error_1.default({
          msg: "{{" + assemblyAccessories.console + "}} isn't assignable to {{" + trough.name + "}}.",
          code: 'NOT_ASSIGNABLE',
          inObject: 'assemblyAccessories.console',
          statusCode: 400
        });
      }
    }
  }

  return error ? error : defaults;
};

exports.validateAssemblyAccessories = {
  console: exports.validateConsole
};
exports.default = exports.validateAssemblyAccessories;